<template>
  <div class="inteBox">
    <intNavheader activeNameCheck="seven"></intNavheader>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div :class="active == '2' ? 'left-btn1' : 'left-btn2'" @click="handleClickBtn('2')">在线问诊</div>
        <div :class="active == '1' ? 'left-btn1' : 'left-btn2'" @click="handleClickBtn('1')">电话问诊</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <el-tabs class="Content1Title" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(tabs, index) in tabData" :key="index" :label="tabs.label" :name="tabs.value" style="height: 100%">
              <div class="flex-l">
                <el-form :model="searchForm" :inline="true">
                  <el-form-item>
                    <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions0" size="small" style="margin-right: 10px; width: 260px"> </el-date-picker>
                  </el-form-item>
                  <el-form-item v-if="activeName == 5">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="
                        searchForm.star = 0;
                        Search();
                      "
                      plain
                      >全部</el-button
                    >
                  </el-form-item>
                  <el-form-item v-if="activeName == 5">
                    <el-rate v-model="searchForm.star" text-color="#ff9900" show-text :texts="texts" @change="Search"> </el-rate>
                  </el-form-item>
                  <el-form-item label="" v-if="activeName != 5">
                    <el-select v-model="searchForm.payType" style="width: 100%" placeholder="支付方式" size="small" @change="Search">
                      <el-option v-for="item in optionsPayType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="" v-if="activeName != 5">
                    <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="" @keyup.enter.native="Search" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="" v-else>
                    <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="订单号/患者名称" @keyup.enter.native="Search" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="Search()">搜索</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <el-table :data="tableData" stripe height="calc(100vh - 280px)" :default-expand-all="true" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" v-if="activeName == 5">
                <el-table-column prop="orderNumber" label="订单编号"> </el-table-column>
                <el-table-column prop="userName" label="用户" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.row.userName }}</div>
                    <div>{{ scope.row.userPhone }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="patientName" label="患者" align="center"> </el-table-column>
                <el-table-column prop="doctorName" label="医生" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.row.doctorName }}</div>
                    <div>{{ scope.row.doctorPhone }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="综合评价" align="center" sortable width="200px">
                  <template slot-scope="scope">
                    <el-rate v-model="scope.row.star" text-color="#ff9900" disabled show-text :texts="texts"> </el-rate>
                  </template>
                </el-table-column>
                <el-table-column prop="payMoney" label="订单金额" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.payMoney?.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付方式" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.payType == 0">余额</p>
                    <p v-if="scope.row.payType == 1">微信</p>
                    <p v-if="scope.row.payType == 2">支付宝</p>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="下单时间" width="160px" align="center" sortable>
                  <template slot-scope="scope">
                    <p>{{ scope.row.createTime | timefilters }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="paySuccessTime" label="支付时间" width="160px" align="center" sortable>
                  <template slot-scope="scope">
                    <p>{{ scope.row.paySuccessTime | timefilters }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.replyContent" class="primary optionBtn" @click="ReplyBtn(scope.row)">回复</span>
                    <span v-else class="info optionBtn">已回复</span>
                    <span class="danger optionBtn" @click="delBtn(scope.row)">删除</span>
                  </template>
                </el-table-column>
                <el-table-column type="expand">
                  <template slot-scope="scope">
                    <div>
                      <div class="flex-start">
                        <div style="margin-right: 10px">问诊结果:</div>
                        <el-rate v-model="scope.row.consultationResult" text-color="#ff9900" disabled show-text :texts="texts1" :max="4"> </el-rate>
                      </div>
                      <div class="flex-start">
                        <div style="margin-right: 10px">服务态度:</div>
                        <el-rate v-model="scope.row.serviceAttitude" text-color="#ff9900" disabled show-text :texts="texts1" :max="4"> </el-rate>
                      </div>
                      <div class="flex-start">
                        <div style="margin-right: 10px">响应时间:</div>
                        <el-rate v-model="scope.row.responseTime" text-color="#ff9900" disabled show-text :texts="texts2" :max="4"> </el-rate>
                      </div>
                      <div>
                        <div style="color: red; margin-right: 20px">用户：{{ scope.row.userName }}：</div>
                        <div>{{ scope.row.content || "" }}</div>

                        <div style="color: red; margin-right: 20px; margin-top: 0" v-if="scope.row.replyContent">医生回复：{{ scope.row.doctorName }}</div>
                        <div>{{ scope.row.replyContent || "" }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" height="calc(100vh - 300px)" v-else>
                <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
                <el-table-column prop="patientName" label="患者" align="center"> </el-table-column>
                <el-table-column prop="diseaseDiagnose" label="患者病症" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.diseaseDiagnose || "-" }}
                  </template>
                </el-table-column>
                <el-table-column prop="payMoney" label="订单金额(元)" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.payMoney.toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付方式" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.payType == 0">余额</p>
                    <p v-if="scope.row.payType == 1">微信</p>
                    <p v-if="scope.row.payType == 2">支付宝</p>
                    <p v-if="scope.row.payType == -1">取消支付</p>
                  </template>
                </el-table-column>
                <el-table-column prop="addTime" label="下单时间" align="center" width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.addTime | timefilters }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="250px">
                  <template slot-scope="scope">
                    <span class="info optionBtn" @click="toOrderInfo(scope.row)">详情</span>
                    <span class="primary optionBtn" @click="toConfirm(scope.row)" v-if="scope.row.state == 1">确认接诊</span>
                    <template v-if="active == 2 && scope.row.state == 2">
                      <span class="primary optionBtn" @click="toContact(scope.row)" v-if="scope.row.doctorFinishState == 0">联系患者</span>
                      <span class="primary optionBtn" @click="toContact(scope.row)" v-if="scope.row.doctorFinishState == 1 && scope.row.userFinishState == 2">再次联系患者</span>
                    </template>
                    <span class="danger optionBtn" @click="toRefund(scope.row)" v-if="scope.row.state == 1">拒绝接诊</span>
                    <span class="danger optionBtn" @click="toRefund(scope.row)" v-if="scope.row.state == 2">终止问诊</span>
                  </template>
                </el-table-column>
                <el-table-column type="expand" v-if="activeName == -3">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="24">
                        <span style="color: #fd403b">拒绝原因：{{ scope.row.refundRefuseReson }}</span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @current-change="changePage" :page-size="pageSize" :current-page="pageIndex" :total="dataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
    <el-dialog :title="`${refuseForm.state == 1 ? '拒绝接诊原因' : '终止接诊原因'}`" :visible.sync="refuseDialog" width="450px" :append-to-body="true" :z-index="99999">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refuseReson">
          <el-input v-model="refuseForm.refuseReson" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')" :loading="isLoad">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="联系患者" :visible.sync="contactDialog" width="500px" :append-to-body="true" :z-index="99999">
      <div>
        <div style="background: linear-gradient(90deg, #f9f7df, #e3f5f3); border-radius: 4px; height: 60px; line-height: 60px; text-align: center; font-weight: bold; font-size: 18px; color: #333333">
          患者手机号：{{ detailInfo.patientName }} <span style="letter-spacing: 4px; font-size: 20px">{{ detailInfo.phone }}</span>
        </div>
        <div style="font-size: 14px; color: #fd403b; margin-top: 10px">* 电话接诊时长：一次30分钟，接诊完成后请点击“完成接诊”按钮</div>
        <div v-if="detailInfo.userFinishState == 2" style="margin-top: 20px">{{ detailInfo.userFinishRemark }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contactDialog = false">取 消</el-button>
        <el-button type="primary" @click="complateBtn()">完成接诊</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回复评论" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="replyContent">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="form.replyContent" autocomplete="off"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveReplyBtn('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import intNavheader from "../../components/intNavheader";
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
import { Chathub } from "../../components/Chathub/Chathub";
export default {
  components: {
    intNavheader,
  },
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    var userChat = new Chathub(this.TokenClient, this.Services.Chathub);
    return {
      DoctorAppointment: doctorAppointment,
      UserChat: userChat,
      searchForm: {
        keyWord: "",
        datepicker: "",
        startTime: "",
        endTime: "",
        payType: "-1",
        star: 0,
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      active: 2,
      activeName: "1",
      optionsPayType: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "0",
          label: "余额",
        },
        {
          value: "1",
          label: "微信",
        },
        {
          value: "2",
          label: "支付宝",
        },
      ],
      tabData: [
        {
          value: "1",
          label: "待接诊",
        },
        {
          value: "2",
          label: "接诊中",
        },
        {
          value: "3,-4",
          label: "已完成",
        },
        {
          value: "-1",
          label: "已取消",
        },
        {
          value: "-2",
          label: "已退款",
        },
        {
          value: "-3",
          label: "已拒绝",
        },
        {
          value: "5",
          label: "评价管理",
        },
      ],
      userInfo: this.$store.state.localData.userInfo,
      tableData: [],
      pageIndex: 1,
      dataTotal: 1,
      pageSize: 15,
      rules: {
        refuseReson: [{ required: true, message: "请填写拒绝接诊原因", trigger: "blur" }],
        replyContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      refuseForm: {
        id: 0,
        refuseReson: "",
      },
      refuseDialog: false,
      formLabelWidth: "15px",
      contactDialog: false,
      detailInfo: {},
      texts: ["差评", "差评", "中评", "中评", "好评"],
      texts1: ["不满意", "一般", "满意", "很满意"],
      texts2: ["不及时", "一般", "及时", "很及时"],
      dialogFormVisible: false,
      form: {
        id: 0,
        replyContent: "",
        // replyUserId: 0,
        // replyUserName: "",
      },
      isLoad: false,
    };
  },
  created() {
    let activeName = JSON.parse(sessionStorage.getItem("activeName")) + "";
    if (activeName && activeName != "null") {
      sessionStorage.removeItem("activeName");
      this.activeName = activeName;
    }
    let active = JSON.parse(sessionStorage.getItem("active")) + "";
    if (active && active != "null") {
      sessionStorage.removeItem("active");
      this.active = active;
    }
    this.getList();
  },
  methods: {
    ReplyBtn(item) {
      this.form = {
        id: item.id,
        replyContent: "",
        // replyUserId: item.doctorId,
        // replyUserName: item.doctorName,
      };
      this.dialogFormVisible = true;
    },
    delBtn(item) {
      var _this = this;
      this.$confirm("确定删除该评论?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _this.DoctorAppointment.DeleteEvaluate(
            item.id,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.pageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    saveReplyBtn(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.DoctorAppointment.SubmitEvaluateReply(
            _this.form,
            function (data) {
              _this.dialogFormVisible = false;
              _this.pageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getList() {
      var _this = this;
      _this.tableData = [];
      var item = _this.searchForm;
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
        item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
      if (this.activeName == 5) {
        _this.DoctorAppointment.GetMyConsultationEvaluatePage(
          this.active,
          item.startTime,
          item.endTime,
          item.star,
          item.keyWord,
          this.pageIndex,
          this.pageSize,
          function (data) {
            _this.tableData = data.data.results;
            _this.pageIndex = data.data.pageIndex;
            _this.pageSize = data.data.pageSize;
            _this.dataTotal = data.data.dataTotal;
          },
          function (err) {
            console.log(err);
          }
        );
      } else {
        _this.DoctorAppointment.GetDoctorOrders(
          this.activeName,
          item.startTime,
          item.endTime,
          this.active,
          item.payType,
          item.keyWord,
          this.pageIndex,
          this.pageSize,
          function (data) {
            _this.tableData = data.data.results;
            _this.pageIndex = data.data.pageIndex;
            _this.pageSize = data.data.pageSize;
            _this.dataTotal = data.data.dataTotal;
          },
          function (err) {
            console.log(err);
          }
        );
      }
    },
    toConfirm(item) {
      var _this = this;
      _this.DoctorAppointment.ConfirmOrder(
        item.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.getList();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    complateBtn() {
      var _this = this;
      _this.DoctorAppointment.DoctorCompleteOrder(
        _this.detailInfo.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.contactDialog = false;
          _this.getList();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    toRefund(item) {
      this.refuseDialog = true;
      this.refuseForm = {
        id: item.orderNumber,
        refusalReason: "",
        state: item.state,
      };
    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.isLoad = true;
          var item = _this.refuseForm;
          if (item.state == 1) {
            _this.DoctorAppointment.RefuseOrder(
              item.id,
              item.refuseReson,
              function (data) {
                _this.isLoad = false;
                _this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                _this.$refs[formName].resetFields();
                _this.refuseDialog = false;
                _this.getList();
              },
              function (err) {
                _this.isLoad = false;
                var jsonObj = JSON.parse(err.msg);
                if (jsonObj.code == "400") {
                  _this.$message({
                    type: "error",
                    message: jsonObj.msg,
                  });
                }
              }
            );
          } else {
            _this.DoctorAppointment.AbortOrder(
              item.id,
              item.refuseReson,
              function (data) {
                _this.isLoad = false;
                _this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                _this.$refs[formName].resetFields();
                _this.refuseDialog = false;
                _this.getList();
              },
              function (err) {
                _this.isLoad = false;
                var jsonObj = JSON.parse(err.msg);
                if (jsonObj.code == "400") {
                  _this.$message({
                    type: "error",
                    message: jsonObj.msg,
                  });
                }
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    toContact(item) {
      console.log(item)
      var _this = this;
      _this.getList();
      _this.UserChat.DoctorAddToChatDiseaseGroup(
        item.userId,
        item.orderNumber,
        function (data) {
          _this.$set(item, "groupId", data.data);
          _this.$bus.$emit("showDialog", item);
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          // if (jsonObj.code == "400") {
          _this.$message({
            type: "error",
            message: jsonObj.msg,
          });
          // }
        }
      );
    },
    toOrderInfo(item) {
      sessionStorage.setItem("activeName", this.activeName);
      sessionStorage.setItem("active", this.active);
      this.$router.push({
        path: "./ConsultationInfo",
        query: {
          orderId: item.orderNumber,
        },
      });
    },
    handleClickBtn(e) {
      this.active = e;
      this.pageIndex = 1;
      this.dataTotal = 0;
      this.searchForm = {
        keyWord: "",
        datepicker: "",
        startTime: "",
        endTime: "",
        payType: "-1",
        star: 0,
      };

      this.getList();
    },
    handleClick(e) {
      this.pageIndex = 1;
      this.dataTotal = 0;
      this.searchForm = {
        keyWord: "",
        datepicker: "",
        startTime: "",
        endTime: "",
        payType: "-1",
        star: 0,
      };
      this.getList();
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getList();
    },
    Search(event) {
      this.pageIndex = 1;
      this.getList();
    },
  },
};
</script>
<style scoped>
.pageBox {
  text-align: center;
  margin-top: 10px;
}
.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}
.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}
.titleTopLeftImg {
  width: 123px;
  height: 24px;
}
.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}
.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}
.el-tabs__item {
  height: 60px;
  color: white !important;
  text-align: center;
  padding-top: 10px;
  font-size: 25px !important;
  background-color: #00afb5 !important;
  border: none !important;
}
.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}
.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.titleTopRight div {
  margin-left: 10px;
}
.titleTopLine {
  width: 100%;
  height: 12px;
}
.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}
.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  /* max-height: 750px; */
  overflow: auto;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  /* margin-top: 0; */
}
.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}
.titleTopCenterCenterTop {
  background-color: #ffffff;
  padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
}
.left-btn1 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: #06add7;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.left-btn2 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
  border: 1px solid #06afd3;
  color: #06add7;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.flex-l {
  display: flex;
  align-items: center;
}
.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Content1Title {
  padding: 20px 40px;
  padding-left: 0;
  font-size: 18px;
  color: #333333;
  padding-bottom: 0;
  text-align: left;
}
.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}
.ageInput {
  width: 80%;
}
.typeChecked {
  font-size: 14px;
  color: #ffffff;
  padding: 0px 15px;
  text-align: center;
  background: #00afb5;
  border-radius: 6px;
  cursor: pointer;
}
.notypeChecked {
  background: #f3f9f9;
  border: 1px solid #b9dcdd;
  padding: 0px 15px;
  border-radius: 6px;
  color: #00afb5;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.table3Box {
  border: 1px solid #b9dcdd;
  border-radius: 6px;
  padding: 30px;
  margin-top: 10px;
}
.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}
.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}
.stepInput {
  width: 60%;
  margin-right: 10px;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
::v-deep .el-pagination {
  padding: 10px 5px;
}
.drawer-box {
  padding: 30px;
}
.el-drawer {
  background-color: #ffffff !important;
  width: 550px !important;
}
.el-drawer__body {
  overflow: auto;
}
.detail-item {
  position: relative;
  margin-bottom: 20px;
}

.detail-item .detail-tit {
  font-size: 18px;
}

.detail-item > p {
  margin: 5px 0;
}

.detail-item > p span {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.detail-item .status {
  position: absolute;
  right: 5px;
  top: 5px;
}

.detail-item .status .text-orange {
  color: orange;
}

.detail-item .status .text-blue {
  color: rgb(47, 0, 255);
}

.detail-item .status p.text-danger {
  color: red;
}

.detail-item .status p.text-succes {
  color: forestgreen;
}
</style>